import { FC } from "react";
import {
  DateValue,
  DatePickerInput as MantineDatePickerInput,
  DatePickerInputProps as MantineDatePickerInputProps,
} from "@mantine/dates";

export interface DatePickerInputProps extends Omit<
  MantineDatePickerInputProps,
  "onChange" | "value" | "valueFormat" | "default"
> {
  value: DateValue | undefined;
  onChange: (value: DateValue | undefined) => void;
  defaultTime?: {
    hours: number;
    minutes?: number;
    seconds?: number;
    ms?: number;
  };
}

const DatePickerInput: FC<DatePickerInputProps> = ({ value, onChange, defaultTime, ...props }) => {
  const handleChange = (date: DateValue | undefined) => {
    if (!date) {
      onChange(null);
      return;
    }

    const next = new Date(date);

    if (value) {
      const current = new Date(value);
      next.setHours(current.getHours(), current.getMinutes(), current.getSeconds(), current.getMilliseconds());
    } else if (defaultTime) {
      next.setHours(defaultTime.hours, defaultTime.minutes ?? 0, defaultTime.seconds ?? 0, defaultTime.ms ?? 0);
    }

    onChange(next);
  };
  return (
    <MantineDatePickerInput
      {...props}
      valueFormat="DD.MM.YYYY"
      styles={{
        //Quirk: DatePickerInput adds 12px padding on left and right, this counteracts that to make it look similar to other inputs
        input: { width: "calc(100% - 24px)" },
        label: { fontWeight: 400, color: "#a4a4a4" },
      }}
      radius={1}
      value={value}
      onChange={handleChange}
    />
  );
};

export default DatePickerInput;
